import { useEffect, useState } from 'react';
import { client } from '../api/client';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [setupToken, setSetupToken] = useState('');
  const [isSetup, setIsSetup] = useState(false);
  const [setupComplete, setSetupComplete] = useState(false);
  const { login, setup, isLoading, error, clearError } = useAuth();

  useEffect(() => {
    client
      .getSetupStatus()
      .then((status) => {
        if (status.setupComplete) {
          setSetupComplete(true);
          setIsSetup(false);
        }
      })
      .catch(() => {
        // Leave the toggle visible if the status call fails.
      });
  }, []);

  useEffect(() => {
    clearError();
  }, [isSetup, clearError]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (isSetup) {
      await setup({ username, password, token: setupToken });
    } else {
      await login({ username, password });
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[var(--bg)] px-4">
      <div className="w-full max-w-sm rounded-2xl border border-[var(--border)] bg-[var(--card)] p-8 shadow-sm">
        <h1 className="text-center text-2xl font-bold text-[var(--fg)]">
          MixerLead Data
        </h1>
        <p className="mt-2 text-center text-sm text-[var(--muted)]">
          {isSetup ? 'Create the first admin account' : 'Sign in to continue'}
        </p>

        {error && (
          <div className="mt-4 rounded-lg border border-[var(--danger)]/30 bg-[var(--danger)]/10 px-3 py-2 text-sm text-[var(--danger)]">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          {isSetup && (
            <div>
              <label className="block text-sm font-medium text-[var(--fg)]">
                Setup token
              </label>
              <input
                type="text"
                value={setupToken}
                onChange={(e) => setSetupToken(e.target.value)}
                required={isSetup}
                className="mt-1 w-full rounded-lg border border-[var(--border)] bg-[var(--bg)] px-3 py-2 text-sm text-[var(--fg)] outline-none focus:border-[var(--primary)] focus:ring-1 focus:ring-[var(--ring)]"
              />
            </div>
          )}

          <div>
            <label className="block text-sm font-medium text-[var(--fg)]">
              Username
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="mt-1 w-full rounded-lg border border-[var(--border)] bg-[var(--bg)] px-3 py-2 text-sm text-[var(--fg)] outline-none focus:border-[var(--primary)] focus:ring-1 focus:ring-[var(--ring)]"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-[var(--fg)]">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={8}
              className="mt-1 w-full rounded-lg border border-[var(--border)] bg-[var(--bg)] px-3 py-2 text-sm text-[var(--fg)] outline-none focus:border-[var(--primary)] focus:ring-1 focus:ring-[var(--ring)]"
            />
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="w-full rounded-lg bg-[var(--primary)] py-2 text-sm font-medium text-[var(--primary-fg)] transition hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {isLoading ? 'Please wait…' : isSetup ? 'Create admin' : 'Sign in'}
          </button>
        </form>

        {!setupComplete && (
          <button
            onClick={() => setIsSetup((s) => !s)}
            className="mt-4 w-full text-center text-sm text-[var(--muted)] hover:text-[var(--primary)]"
          >
            {isSetup ? 'Already have an account? Sign in' : 'First time? Create admin account'}
          </button>
        )}
      </div>
    </div>
  );
}
